module.exports = __webpack_public_path__ + "static/media/90.ad2de57e.png";